import { toast } from "sonner";
import { isUnreachableError } from "../lib/api";

/**
 * Mostra toast "Servizio non raggiungibile" con bottone Riprova.
 * Da chiamare in catch() quando `isUnreachableError(err) === true`.
 *
 * Esempio:
 *   try { await api.post(...) }
 *   catch (err) {
 *     if (isUnreachableError(err)) {
 *       showServiceUnavailable(() => retryAction());
 *     } else { toast.error(err.response?.data?.detail || "Errore"); }
 *   }
 */
export function showServiceUnavailable(onRetry) {
    toast.error("Servizio non raggiungibile. Riprova.", {
        id: "service-unavailable",   // dedupe
        duration: 20000,              // FIX B1 2026-11-02: 20s persistente (prima 8s)
        action: onRetry ? {
            label: "Riprova",
            onClick: () => {
                toast.dismiss("service-unavailable");
                try { onRetry(); } catch (_) { /* noop */ }
            },
        } : undefined,
    });
}

/**
 * Wrapper utility — esegue `fn()` e, se fallisce con unreachable error,
 * mostra toast con Riprova che rilancia la stessa `fn`.
 * Altri errori vengono rilanciati per gestione specifica a monte.
 */
export async function withServiceUnavailableGuard(fn) {
    try {
        return await fn();
    } catch (err) {
        if (isUnreachableError(err)) {
            showServiceUnavailable(() => withServiceUnavailableGuard(fn));
            return null;
        }
        throw err;
    }
}
